import { generateApiActionTypes } from 'utils/actions/generateActionTypes'
import { ENDPOINTS } from 'utils/api/callApi'

export const APPOINTMENT_REFERENCE_ACTION_TYPES = generateApiActionTypes('APPOINTMENT_REFERENCE')

export const updateAppointmentReference = (
  id: string | number,
  confirmationReference: string,
  autoConfirmToken: string
) => ({
  payload: {
    callApi: true,
    requestData: {
      method: 'PUT',
      endpoint: ENDPOINTS.shipmentStops,
      group: 'update_confirmation_reference',
      id,
      body: {
        confirmationReference,
        autoConfirmToken,
      },
    },
    actionTypes: Object.keys(APPOINTMENT_REFERENCE_ACTION_TYPES),
  },
})
